<template>
  <footer id="footer" class="app-footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="col-lg-6 mb-0">
          <div
            class="text-sm text-center text-muted"
            :class="$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            <a
              href="https://huestimates.com/"
              class="font-weight-bold"
              target="_blank"
            >Progress</a>
            IMS Life Insurance
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>